import React from 'react';
import ReactLoading from 'react-loading';


const PageLoader = ({ type, color }) => (
    <ReactLoading type={type} color={color} height={200} width={175} className="page-loader" />
);

export default PageLoader;



// WEBPACK FOOTER //
// ./src/components/loader/PageLoader.js